module.exports = __webpack_public_path__ + "img/9.00f228ef.jpg";